import gql from 'graphql-tag';

// Comments v3 (plan 1): the author deletes the own comment (its replies go with it).
export default gql`
mutation deletePageComment($commentId: Int!) {
  delete_page_comments_by_pk(comment_id: $commentId) {
    comment_id
  }
}
`;
